import {useEffect} from 'react';
import {Table, Button, Tooltip} from 'antd';
import {CopyOutlined} from '@ant-design/icons';
import DBModal from 'components/modal/modal';
import styles from './viewOrders.module.scss';
import {ModalShell} from './ui/ModalShell';

const columns = [
  {title: 'Order ID', dataIndex: 'id', key: 'id'},
  {title: 'Symbol', dataIndex: 'symbol', key: 'symbol'},
  {title: 'Direction', dataIndex: 'direction', key: 'direction'},
  {title: 'Type', dataIndex: 'type', key: 'type'},
  {title: 'Broker', dataIndex: 'broker', key: 'broker'},
  {title: 'Quantity', dataIndex: 'quantity', key: 'quantity'},
  {title: 'Limit Price', dataIndex: 'limitPrice', key: 'limitPrice'},
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    render: value => (value != null ? `CFA ${value.toLocaleString()}` : '-'),
  },
];

const ExecutionSummaryModal = ({open, data, onClose}) => {
  if (!data) return null;
  const dispatched = data.dispatched || [];

  const downloadCsv = rows => {
    if (!rows?.length) return;
    const header = [
      'Order ID',
      'Symbol',
      'Direction',
      'Type',
      'Broker',
      'Quantity',
      'Price',
      'Limit',
    ];
    const csvRows = rows.map(row => [
      row.id || '',
      row.symbol || '',
      row.direction || '',
      row.type || '',
      row.broker || '',
      row.quantity ?? '',
      row.price ?? '',
      row.limit ?? '',
    ]);
    const csvContent = [header, ...csvRows]
      .map(cols =>
        cols.map(col => `"${`${col}`.replace(/"/g, '""')}"`).join(','),
      )
      .join('\n');
    const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `execution_${data.key || 'summary'}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (open) {
      downloadCsv(dispatched);
    }
  }, [open, dispatched]);

  return (
    <DBModal
      isOpen={open}
      handleClose={onClose}
      width={780}
      destroyOnClose
      content={
        <ModalShell
          title="Orders dispatched"
          subtitle="Keep this tracking key — it is how you look the run up again from Order Book Status."
          footer={
            <>
              <Button type="default" onClick={() => downloadCsv(dispatched)}>
                Download CSV
              </Button>
              <Button type="primary" onClick={onClose}>
                Close
              </Button>
            </>
          }>
          <div className={styles.executionModal}>
            <div className={styles.executionHeader}>
              <div className={styles.executionKey}>
                <span>{data.key || '—'}</span>
                {data.key ? (
                  <Tooltip title="Copy key">
                    <Button
                      type="text"
                      icon={<CopyOutlined />}
                      onClick={() =>
                        navigator.clipboard.writeText(String(data.key))
                      }
                    />
                  </Tooltip>
                ) : null}
              </div>
            </div>
            <Table
              dataSource={dispatched}
              columns={columns}
              className="antd-table"
              rowKey="key"
              pagination={false}
              locale={{emptyText: 'No dispatched orders returned'}}
            />
          </div>
        </ModalShell>
      }
    />
  );
};

export default ExecutionSummaryModal;
